export default "__VITE_ASSET__DO3IVNtU__"